import Vue from 'vue';
import { Vue2K18nNext } from '@k18n/vue2-k18n-next';
import { HotUpdate } from '@k18n/hot-update';
var langs = require('@k18n/operation-creator-monetization-h5-language/tags/attribution/index.json');
Vue.use(Vue2K18nNext, {
  messages: [langs],
  plugins: [new HotUpdate()]
});